/**
 * @file: thread-tabs/index.web.tsx — WEB shell
 *
 * The inbox's two-tab thread list container (通知 / 聊天消息) on web. Unlike the
 * native shell (`index.tsx`), this renders only the active tab directly —
 * `react-native-pager-view` has no web implementation (importing it breaks the
 * web bundle) and the desktop column doesn't need swipe. Metro/webpack resolve
 * this file ahead of `index.tsx` on web. Shared logic lives in `useThreadTabs`.
 */

import { FC, memo } from 'react';
import { View } from 'react-native';
import { ChatThreads } from './chat-threads';
import { FeedThreads } from './feed-threads';
import { InboxTabBar } from './tab-bar';
import { useThreadTabs } from './use-thread-tabs';

export const ThreadTabs: FC = memo(() => {
  const m = useThreadTabs();

  return (
    <View style={{ flex: 1 }}>
      <InboxTabBar
        tab={m.tab}
        chat={m.chat}
        feedUnread={m.feedUnread}
        chatUnread={m.chatUnread}
        onTabChange={m.onTabChange}
        onOpenContacts={m.openContacts}
        onMarkAllFeedRead={m.markAllFeedRead}
      />
      <View style={{ flex: 1 }}>
        {m.tab === 'notifications' ? <FeedThreads /> : <ChatThreads />}
      </View>
    </View>
  );
});
